if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        // Obtener URL del producto
        const productUrl = opener.getAttribute('data-product-url');
        
        fetch(productUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            // Cargar variantes directamente desde la URL del producto
            this.loadVariantsFromProductPage(productUrl);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // Nueva función para cargar variantes desde la página del producto
      loadVariantsFromProductPage(productUrl) {
        fetch(productUrl)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Buscar el template de variantes
            const variantsTemplate = doc.querySelector('[id*="ss-product-variants-template"]');
            
            if (variantsTemplate && variantsTemplate.content) {
              // Clonar el contenido del template
              const variantsContent = variantsTemplate.content.cloneNode(true);
              const variantsSection = variantsContent.firstElementChild;
              
              if (variantsSection) {
                // Buscar donde insertar (después del precio)
                const priceElement = this.modalContent.querySelector('.price, .product__price, [class*="price"]');
                
                if (priceElement) {
                  // Crear contenedor estable
                  const container = document.createElement('div');
                  container.className = 'ss-product-variants-modal-container';
                  container.style.cssText = `
                    margin-top: 1rem;
                    padding-top: 1rem;
                    border-top: 1px solid #e5e5e5;
                    min-height: 120px;
                  `;
                  
                  // Limpiar IDs para evitar duplicados
                  this.cleanDuplicateIds(variantsSection);
                  
                  container.appendChild(variantsSection);
                  
                  // Insertar después del precio
                  priceElement.parentNode.insertBefore(container, priceElement.nextSibling);
                  
                  // Inicializar funcionalidad
                  setTimeout(() => {
                    this.initializeVariants(container);
                  }, 200);
                }
              }
            }
          })
          .catch(error => {
            console.log('No se pudieron cargar las variantes:', error);
          });
      }

      // Limpiar IDs duplicados
      cleanDuplicateIds(element) {
        const timestamp = Date.now();
        const elementsWithId = element.querySelectorAll('[id]');
        
        elementsWithId.forEach((el, index) => {
          const oldId = el.id;
          const newId = `modal-${oldId}-${timestamp}-${index}`;
          el.id = newId;
          
          // Actualizar referencias
          const references = element.querySelectorAll(`[for="${oldId}"], [aria-labelledby="${oldId}"], [href="#${oldId}"]`);
          references.forEach(ref => {
            if (ref.getAttribute('for') === oldId) ref.setAttribute('for', newId);
            if (ref.getAttribute('aria-labelledby') === oldId) ref.setAttribute('aria-labelledby', newId);
            if (ref.getAttribute('href') === `#${oldId}`) ref.setAttribute('href', `#${newId}`);
          });
        });
      }

      // Inicializar variantes
     

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
